var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsUnselected = function SvgPartsUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m2.167 18.307 7.997 4.532c.57.325 1.108.325 1.687 0l7.987-4.532c.935-.528 1.422-1.067 1.422-2.52V7.739c0-1.056-.386-1.717-1.24-2.205L12.828 1.45c-1.23-.71-2.419-.71-3.648 0L1.995 5.534C1.13 6.022.745 6.683.745 7.74v8.048c0 1.453.498 1.992 1.422 2.52m8.84-7.143-7.844-4.44L9.86 2.902c.783-.448 1.504-.458 2.297 0l6.696 3.82zm-7.925 5.802c-.59-.326-.793-.671-.793-1.23V8.064l7.916 4.522v8.434zm15.851 0L11.8 21.02v-8.434l7.916-4.522v7.672c0 .559-.203.904-.783 1.23"
  })));
};
export default SvgPartsUnselected;